import React, { Fragment, useEffect, useState } from "react";
import Input from "Components/Input/Input";
import { useDispatch, useSelector } from "react-redux";
import { verifyAuth } from "Stores/actions";
import showNotify from "Helpers/Notify";
import { useSetState } from "Helpers/Hooks";
import AuthHeader from "../components/AuthHeader";
import MuiButton from "Components/MuiButton/MuiButton";
import codeMask from "Components/Input/components/codeMask";
import AuthService from "Services/http/endpoints/AuthService";
import { Typography, useTheme } from "@material-ui/core";
import StatusHandler from "Helpers/StatusHandler";
import Translator from "Languages/Utility/Translator";
// import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useTranslation } from 'react-i18next';
import VerificationInput from "react-verification-input";

// function Verify(props) {
function Verify() {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const dispatch = useDispatch();
  const [seconds, setSeconds] = useState(120);
  const [formValid, setFormValid] = useState(false);
  const [softClick, setSoftClick] = useState(false);
  const [header, setHeader] = useState({Authorization: `Bearer `});
  const ref = React.createRef(null);
  const [state, setState] = useSetState({
    authNumber: {
      value: "",
      validation: {
        required: true,
      },
    },
  });

  useEffect(() => {
   if(ref) ref.current.focus()
  },[])

  const { verifyType, userId, verifyData, FoPaheader } = useSelector((state) => ({
    verifyType: state.auth.verifyType,
    userId: state.auth.userId,
    verifyData: state.auth.verifyData,
    FoPaheader: state.auth.FoPaheader,
  }));

  useEffect(() => {
    let timer = null;
    if (seconds > 0) {
      timer = setTimeout(() => {
        setSeconds(seconds - 1);
      }, 1000);
    } else {
      clearTimeout(timer);
      timer = null;
    }
    return () => {
      if(timer) {
        clearTimeout(timer);
      }
    }
  }, [seconds]);

  useEffect(() => {
    if(verifyType === "resetPassword") {
      setHeader(FoPaheader);
    } else {
      resendCode();
    }
  },[])

  const setValue = (name, value, validation) => {
    setState({ [name]: { value: value } });
    setFormValid(validation);
    if(value.length === 5 && seconds > 0) {
      setSoftClick(true);
    }
  };

  useEffect(() => {
    if(softClick) {
      setSoftClick(false);
      onUserAuth();
    }
  },[softClick])

  const verificationCode = (value) => {
    setValue('authNumber', value, value.length === 5 ? true : false)
  }

  const onUserAuth = async () => {
    const { authNumber } = state;
    const type = 2; // verify with phone
    let data = null;
    if (formValid) {
      try {
        if (verifyType === "signUp") {
          data = {
            Token: authNumber.value,
            Account: userId,
            Type: type,
          };
        } else if (verifyType === "resetPassword") {
          data = {
            Value: userId,
            Type: type,
            Code: authNumber.value,
          };
        } else if (verifyType === "signIn") {
          data = {
            UserName: userId,
            password: "",
            SelectedProvider: "Phone",
            Code: authNumber.value,
          };
        }
        await dispatch(verifyAuth(data, verifyType, header));
      } catch (err) {
      console.error('[catch error]', err)
    }
    } else {
      showNotify({
        text: t('invalidAuthCode'),
        customClass: "error",
      });
    }
  };

  const resendCode = async () => {
    try {
      if (verifyType === "signIn") {
        const data = {
          UserName: userId,
          SelectedProvider: "Phone",
        };
        const header = {
          Authorization: `Bearer ${verifyData.AccessToken.Token}`,
        };
        const response = await AuthService.sendCode(data, header);
        setSeconds(120);
        let err = StatusHandler(response);
        if (!err.isFail) {
          if (response.data.StatusCode === 222) {
            const newHeader = {
              Authorization: `Bearer ${response.data.Value.Token}`,
            };
            setHeader(newHeader);
          }
        }
      }
      
      if (verifyType === "resetPassword") {
        const token = ""; // await props.googleReCaptchaProps?.executeRecaptcha();
        const data = {
          Value: userId,
          Type: 2,
          keyCap: token
        };
        const response = await AuthService.authResetPassword(data);
        setSeconds(120);
        let err = StatusHandler(response);
        if (!err.isFail) {
          if (response.data.StatusCode === 222) {
            const newHeader = {
              Authorization: `Bearer ${response.data.Value.Token}`,
            };
            setHeader(newHeader);
          }
        }
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  return (
    <Fragment>
      <AuthHeader
        title={t('sendVerificationCode')}
        description={t('enterCode')}
      />
      <form className={`mt-4 ${direction === 'rtl' ? "text-end" : "text-start"}`}>
        <div className="VerificationInput">
          <Translator id="sent_code" />
          <VerificationInput 
            ref={ref}
            classNames={{character: "VerificationInputCharacter"}}
            validChars="0-9"
            length={5}
            onChange={verificationCode}
            inputProps={{ inputMode: "numeric" }} />
        </div>
        <div className="mt-3 ">
          {seconds === 0 ? (
            <Fragment>
              <Typography
                component="div"
                variant="body1"
                className="text-center"
              >
                <span>{<Translator id="did_you_receive_text_message" />}</span>
              </Typography>
              <div className="d-flex justify-content-center m-3">
                <MuiButton
                  className="w-100"
                  onClick={resendCode}
                  variant="contained"
                  title={<Translator id="resend" />}
                />
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <Typography
                component="div"
                variant="body1"
                className="text-center"
              >
                <span>
                  {<Translator id="please_wait_to_receive_the_verification_code" />}
                  {seconds < 10 ? `0${seconds}` : seconds}
                </span>
              </Typography>
              <div className="d-flex justify-content-center m-3">
                <MuiButton
                  className="w-100"
                  color="primary"
                  title={<Translator id="btnCheckCode" />}
                  onClick={onUserAuth}
                />
              </div>
            </Fragment>
          )}
        </div>
      </form>
    </Fragment>
  );
}

export default Verify;
// export default withGoogleReCaptcha(Verify);